import { apiClient } from '../../utils/helpers';
import { PayPalButtons } from "@paypal/react-paypal-js";

const PAYPAL_ENABLED = true;

export default function Paypal(props) {

  if (!PAYPAL_ENABLED) {
    return (
      <p style={{ color: '#888', fontSize: '0.9rem', margin: '8px 0' }}>
        PayPal payment is temporarily unavailable.
      </p>
    );
  }

  const createOrder = (data, actions) => {
    props.setPaying(true)
    return apiClient.post(`/api/paypal_create`,{
      'code' : props.bkinfo.code
    })
    .catch(function(err){
      console.log(err)
    })
    .then((response) => {
      return response.data.id
    })
  }

  const onApprove = (data, actions) => {
    return apiClient.post('/api/paypal_capture' , {
      'oid' : data.orderID,
    })
    .catch(function(err){
      console.log(err)
    })
    .then(function(response) {
      if(response.data === 'COMPLETED') {
        props.setSucceeded(true)
      } else {
        props.setPaymentErrorMessage("Something went wrong while confirming your Paypal payment. Please contact us with your booking code.");
      }
      props.setPaying(false)
    });
  };

  const cancelOrder = () => {
    props.setPaying(false)
  }

  return (
      <>
        <PayPalButtons
          disabled={props.paying ? true : false}
          style={{
            color: "gold",
            height: 55,
            shape: 'pill',
            label: "pay",
            tagline: false,
            layout: "horizontal",
          }}
          createOrder={createOrder}
          onApprove={onApprove}
          onCancel={cancelOrder}
        />
      </>

  );
}
